<template>
  <v-card class="product-compaire">
    <v-card-title class="pc-title" primary-title @click="openProductInSearchEngine"> {{ categoryData.title.text }} </v-card-title>
    <div class="pc-content"  @click="openProductInSearchEngine">
      <v-card-text class="pc-text">
        <div v-for="(text, index) in categoryData.subtitle.text.split('\n')" :key="index">
          {{ text }}
        </div>
        <v-html>{{  }}</v-html>
      </v-card-text>
      <v-img contain class="pc-img" height="174px" max-width="168px" :src="categoryData.image.src"> </v-img>
      <div class="pc-img__copyright">{{ categoryData.image.imageProductCopyright }}</div>
    </div>
    <v-card-actions class="pc-actions">
      <div class="pc-act__left">
        <div class="pc-act__title">{{ categoryData.actiontitle.text }}</div>
        <v-flex class="pc-act__text">
          <div class="card-action__text">{{ categoryData.actiontext.text }}</div>
        </v-flex>
      </div>
      <div class="pc-buttons">
        <v-btn class="primary-btn" @click="submitAnswer()" v-show="showSubmitButton"
          ><div class="btn-text">{{ submitButtonText }}</div></v-btn
        >
        <v-btn class="primary-btn" @click="addToBasket()" :disabled="isProductInBasket()" v-show="showBasketButon"
          ><div class="btn-text"><v-icon>{{ getBasketButtonIcon() }}</v-icon>{{ getBasketButtonText() }}</div></v-btn
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    categoryData: Object,
    indexOfCard: Number
  },
  methods: {
    submitAnswer() {
      let newInput = {
        button: {
          clicked: true,
          indexOfCategoryCard: this.$props.indexOfCard,
        },
      }
      console.log(newInput)
      this.$emit("submitAnswer", newInput)
    },
    addToBasket() {
      let productData = {
        productId: this.$props.categoryData.meta.productID,
        productTitle: this.$props.categoryData.title.text,
        productImage: this.$props.categoryData.image.src,
        costInformation: this.$props.categoryData.meta.costInformation
      }
      this.$emit("addToBasket", productData)
      this.$forceUpdate() // force re-render to show changes
    },
    // returns true if the product is already in the basket, otherwise false
    isProductInBasket() {
      return this.$props.categoryData.meta?.productID in this.$store.state.basketModule.basket
    },
    getBasketButtonText() {
      if (this.isProductInBasket() === true) {
        return "Gemerkt"
      }
      else {
        return "Merken"
      }
    },
    getBasketButtonIcon() {
      if (this.isProductInBasket() === true) {
        return "mdi-bookmark-check"
      }
      else {
        return "mdi-bookmark"
      }
    },
    openProductInSearchEngine(){
      // Note: currently only L2 products return 
      let routeData = this.$router.resolve({name: 'categoryDetailView', params: {seoID: this.$props.categoryData.meta.seoID}});
      window.open(routeData.href, '_blank');    }
  },
  computed: {
    showBasketButon() {
      return this.$props.categoryData.meta?.productID !== undefined
    },
    showSubmitButton() {
      return this.categoryData.button !== undefined
    },
    submitButtonText() {
      if (this.categoryData.button === undefined) {
        return ""
      } else {
        return this.categoryData.button.text
      }
    },
  },
}
</script>

<style></style>
